import React, { useContext } from 'react'
import {Link} from 'react-router-dom'
import {faUsers} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import Label from 'components/label'
import {TeacherContext} from 'teacher/context'
export default function Group(props) {

  const context = useContext(TeacherContext)
  const {translate, link} = context

  const {name, students, id} = props
  const studentCount = students.length

  return (
    <div className="group">
      <Link className="group-link"
        to={link({groupId: id}, '/:languageId/:role/:page/:groupId/students', {preserveQuery: true})}
      >
        <div className="icon-wrapper">
          <div className="icon">
            <FontAwesomeIcon icon={faUsers} />
          </div>
        </div>
        <div className="label">
          <div className="name">
            <Label value={name} maxLength={25} />
          </div>
          <div  className="count">
            {studentCount}{" "}{translate(`student${studentCount == 1 ? '' : 's'}_label`)}
          </div>
        </div>
    </Link>
    </div>
  )
}